<div class="replace-delete">
  <!-- Dialog header -->
  <div class="replace-delete-header mb-0">
    <div class="flex-between-center width-100p">
      <div class="flex-start-center gap-2">
        <div class="heading-left-icon flex-center-center">
          <i class="fas fa-exclamation-triangle font-16"></i>
        </div>
        <p class="font-700 font-18 mt-1 mb-0">
          {{dialogTitle}}
        </p>
      </div>

      <i id="replace-delete-dialog-close-icon" class="far fa-times pointer dialog-close" (click)="closeDialog()"></i>
    </div>
  </div>

  <!-- Dialog body -->
  <!-- Dialog type = Category -->
  <ng-container *ngIf="dialogType === 'category'">
    <div class="replace-delete-body border-bottom-light" *ngIf="!isOnlyDelete">
      <div class="ui-g-12 p-0 font-14 mb-2">
        <span>
          Are you sure you want to delete this category? There are {{count}} items associated with this category. Please
          select an option to proceed:
        </span>
      </div>

      <div class="ui-g-12 p-0 font-14 font-400 mt-2 mb-2" *ngFor="let option of deleteCategoryOption;let i = index">
        <app-radio-button [selectedValue]="selectedDelete" name="deleteCategoryOption" [label]="option.name"
          [value]="option.field" styleClassLabel="font-15 font-600 font-gray-35 pl-1"
          (appChange)="handleAppSettingChange($event)"></app-radio-button>
        <div class="font-13 ml-4 font-gray-35">{{option.text}}</div>
      </div>

      <div class="ui-g-5 p-0 font-14 font-400 mb-2 mt-4 delete-category">
        <app-dropdown placeholder="Category*" scrollHeight="120px" field="name" [disabled]="type"
          [closeOnSelection]="true" [floatingLabel]="true" [hasEditableField]="false" [value]="selectedValue || ''"
          [isDropdownIconVisible]="true" [hasCustomItemTemplate]="true" [setPositionDynamically]="true"
          styleClassDropdownList="markup-dropdown-list-wrapper" [truncateString]="true" [fontSize]="14"
          [listItemFontSize]="14" [options]="categoryResults" (appSelect)="onAutoCompleteSelect($event, 'tags')">
          <ng-template let-item appTemplate="item">
            <div class="ui-g p-0">
              <div class="ui-g-12 p-0 flex-start-start">
                <div class="flex-column font-12">
                  <span class="font-12 font-secondary-700">
                    <span>
                      {{ item?.name }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </ng-template>
        </app-dropdown>
      </div>
      <!-- body end -->
    </div>

    <div class="delete-body border-bottom-light" *ngIf="isOnlyDelete">
      <div class="ui-g-12 p-0 font-14 font-500">
        <span>
          Are you sure you want to delete this category?
        </span>
      </div>
    </div>
  </ng-container>

  <!-- Dialog type = Sales Group -->
  <ng-container *ngIf="dialogType === 'salesGroup'">
    <div class="replace-delete-body border-bottom-light">
      <div class="font-14 mb-2">
        Are you sure you want to delete this Sales Group? There are {{salesCodeCount}} Sales Code associated with this
        Sales Group. Please select new Sales Group to replace the existing one.
      </div>

      <app-auto-complete id="delete-replace-sales-group-ac" listId="delete-replace-sales-group-ac-list"
        placeholder="Select group" field="name" scrollHeight="168px" theme="border" editableItemIdKey="_id"
        editFieldLabel="Create Sales Group" [hasCustomEditableField]="true" [disabled]="false" [hasEditableField]="true"
        [hasFutureSelectionField]="false" [closeOnSelection]="true" [isDropdownIconVisible]="true"
        [hasStaticUnassignedFiled]="false" [suggestions]="salesGroups" [listItemFontSize]="14" [fontSize]="14"
        [value]="updateSalesGroup?.name" (appSelect)="onSalesGroupSelect($event)"
        (appChange)="onSalesGroupSelect($event)" (appCompletedMethod)="onSalesGroupSearch($event)"
        (appClear)="onSalesGroupSearch('')">
        <ng-template let-item let-editItem="editItem" appTemplate="item">
          <div id="delete-replace-sales-group-name-{{item._id}}" class="tag-item flex-between-center">
            <div>{{ item?.name }}</div>
          </div>
        </ng-template>

        <ng-template let-item let-close appTemplate="editable">
          <div>
            <div *ngIf="!isSalesGroupCreationEnabled"
              (click)="$event.stopPropagation(); handleToggleSalesGroupCreate(true)">
              Create Sales Group
            </div>

            <ng-container *ngIf="isSalesGroupCreationEnabled">
              <div class="ui-g-12 p-0 font-gray">
                <div class="ui-g-6">
                  <label class="font-12 font-gray-700 font-600" for="group-name">
                    Sales Group Name
                  </label>

                  <app-input placeholder="Enter group name" [isInvalid]="errors?.name"
                    styleClass="input-create-new-sale-code" theme="border" [fontSize]="12" [value]="newSalesGroup?.name"
                    [isInvalid]="errors?.salesGroup?.fields?.name" (appFocus)="onFocus('name')"
                    (appChange)="handleSalesGroupChange('name', $event)"></app-input>
                </div>

                <div class="ui-g-6">
                  <label class="font-12 font-gray-700 font-600" for="group-name">
                    Sales Group Code
                  </label>

                  <app-input placeholder="Enter Code" [isInvalid]="errors?.groupCode"
                    styleClass="input-create-new-sale-code" theme="border" [fontSize]="12"
                    [value]="newSalesGroup?.groupCode" [isInvalid]="errors?.salesGroup?.fields?.groupCode"
                    (appFocus)="onFocus('groupCode')"
                    (appChange)="handleSalesGroupChange('groupCode', $event)"></app-input>
                </div>
              </div>

              <div *ngIf="isMidasRoyaltyReportsEnabled" class="ui-g-12 p-0 font-gray">
                <div class="ui-g-6">
                  <label class="font-12 font-gray-700 font-600" for="group-name">
                    M2 Sales Group Name
                  </label>

                  <app-input placeholder="Enter group name" [isInvalid]="errors?.m2GroupName"
                    (appFocus)="onFocus('m2GroupName')" styleClass="input-create-new-sale-code" theme="border"
                    [fontSize]="12" [value]="newSalesGroup?.m2GroupName"
                    [isInvalid]="errors?.salesGroup?.fields?.m2GroupName"
                    (appChange)="handleSalesGroupChange('m2GroupName', $event)"></app-input>
                </div>

                <div class="ui-g-6">
                  <label class="font-12 font-gray-700 font-600" for="group-name">
                    M2 Sales Group Code
                  </label>

                  <app-input placeholder="Enter Code" [isInvalid]="errors?.m2GroupCode"
                    (appFocus)="onFocus('m2GroupCode')" styleClass="input-create-new-sale-code" theme="border"
                    [fontSize]="12" [value]="newSalesGroup?.m2GroupCode"
                    [isInvalid]="errors?.salesGroup?.fields?.m2GroupCode"
                    (appChange)="handleSalesGroupChange('m2GroupCode', $event)"></app-input>
                </div>
              </div>

              <div class="ui-g-12 flex-between-end">
                <div class="ui-g-6">&nbsp;</div>
                <div class="ui-g-6">
                  <div class="d-flex justify-content-end">
                    <button [disabled]="loader.isSalesGroupCreating" id="sales-code-cancel-btn"
                      class="btn btn-white pointer btn-submit ml-2"
                      (click)="$event.stopPropagation(); handleToggleSalesGroupCreate(false)">
                      Cancel
                    </button>

                    <button id="sales-code-save-btn" class="btn btn-primary btn-submit pointer ml-2"
                      tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
                      [disabled]="loader.isSalesGroupCreating" (click)="handleSalesGroupCreate(close)">
                      <span class="font-bold">Create</span>
                      <i *ngIf="loader.isSalesGroupCreating" class="fal fa-spinner rotate ml-2"></i>
                    </button>
                  </div>
                </div>

              </div>
            </ng-container>
          </div>
        </ng-template>
      </app-auto-complete>
    </div>
  </ng-container>



  <!-- Star Footer -->
  <div class="ui-g-12 flex-between-end dialog-footer part-footer border-top">
    <div class="replace-delete-dialog-footer d-flex justify-content-end width-100p">
      <ng-container *ngIf="dialogType === 'salesGroup'">
        <button id="sales-group-delete-and-replace" class="btn btn-delete btn-primary btn-submit pointer ml-2"
          [disabled]="!updateSalesGroup?._id || loader.isSalesGroupDeleting" (click)="deleteAndReplaceSalesCode()">
          <span [ngClass]="{ 'pr-2': loader.isSalesGroupDeleting }">Replace and Delete</span>
          <i *ngIf="loader.isSalesGroupDeleting" class="far fa-spinner rotate"></i>
        </button>
      </ng-container>

      <ng-container *ngIf="dialogType === 'category'">
        <div>
          <button id="part-cancel-btn" class="btn btn-white btn-border pointer btn-submit ml-2"
            (click)="cancelDialog()">
            Cancel
          </button>

          <button id="part-save-btn" class="btn btn-delete  btn-primary btn-submit pointer ml-2" [disabled]="isValid"
            (click)="onSubmit('replaceAndDelete')" *ngIf="!isOnlyDelete && !type">
            <span [ngClass]="{ 'pr-2': isLoading }">Replace and Delete</span>
            <i *ngIf="isLoading" class="far fa-spinner rotate"></i>
          </button>

          <button id="part-save-btn" class="btn btn-delete btn-primary btn-submit pointer ml-2"
            [disabled]=" isDeleteLoading " (click)="onSubmit('delete')" *ngIf="type">
            <span [ngClass]="{ 'pr-2': isDeleteLoading }">Delete</span>
            <i *ngIf="isDeleteLoading" class="far fa-spinner rotate"></i>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
  <!-- End Add Parts Footer -->
</div>
